import { h } from "omi";

import { IconProps } from "@/wc/components";

export function HeartHandIcon({ width, height }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} viewBox="0 0 16 16">
      <g clip-path="url(#a)">
        <path
          d="M4.00016 13.3915h1.7402c.22689 0 .45239.027.67234.081l1.83872.4468c.39897.0972.81459.1067 1.21773.0284l2.03295-.3955c.5371-.1046 1.0311-.3618 1.4183-.7384l1.4384-1.3992c.4107-.3989.4107-1.0462 0-1.4458-.3699-.35975-.9555-.40025-1.3739-.09517l-1.6763 1.22307c-.2401.1755-.5322.2699-.8327.2699H8.85716h1.03038c.58076 0 1.05116-.4576 1.05116-1.0226v-.2045c0-.46907-.3282-.8781-.7958-.99149l-1.59034-.38676c-.25881-.06277-.52386-.09449-.7903-.09449-.64321 0-1.8075.53254-1.8075.53254l-1.9546.8174M1.3335 9.73343v3.86667c0 .3734 0 .56.07266.7027a.66667.66667 0 0 0 .29134.2913c.14261.0727.32929.0727.70266.0727h.53334c.37336 0 .56005 0 .70266-.0727.12544-.0639.22742-.1659.29134-.2913.07266-.1427.07266-.3293.07266-.7027V9.73343c0-.37337 0-.56006-.07266-.70266a.666731.666731 0 0 0-.29134-.29135c-.14261-.07266-.3293-.07266-.70266-.07266h-.53334c-.37337 0-.56005 0-.70266.07266a.666628.666628 0 0 0-.29134.29135c-.07266.1426-.07266.32929-.07266.70266Zm10.1276-7.3385c-.3979-.83257-1.3152-1.27365-2.20731-.84792-.8921.42572-1.27216 1.43534-.89866 2.32163.23084.54776.8922 1.61145 1.36376 2.34414.17424.27072.26135.40608.38861.48527.1091.06792.2458.10453.3743.10028.1497-.00495.2929-.07862.5791-.22595.7748-.39874 1.8794-.98925 2.3531-1.3482.7667-.58081.9565-1.64837.3826-2.45993-.5739-.81155-1.5747-.89141-2.3355-.36932Z"
          stroke="#667085"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
